import { useEffect, useState } from "react";
import useTableCtx from "../tableContext/useTableCtx";
import { tableControlContainerClasses } from "./tableControlStyles";
import TableFilterSelect from "./TableFilterSelect";

function TableGlobalFilter() {
  const tableContext = useTableCtx()!;

  const { setTableGlobalFilter, globalFilterOptions } = tableContext;

  const [filterTerm, setFilterTerm] = useState<string>("");

  useEffect(() => {
    setTableGlobalFilter && setTableGlobalFilter(filterTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterTerm]);

  if (!globalFilterOptions) {
    return null;
  }

  return (
    <div className={tableControlContainerClasses}>
      <div className="w-[180px] max-w-full">
        <TableFilterSelect
          name="filter"
          label="Filtreaza tabelul"
          value={
            filterTerm ||
            (globalFilterOptions.find((option) => option.value === 0)?.value ??
              globalFilterOptions[0]?.value ??
              "")
          }
          options={globalFilterOptions}
          onChange={setFilterTerm}
        />
      </div>
    </div>
  );
}

export default TableGlobalFilter;
